import { Box, Footer, List, styled } from '@lanekassen/ui';
import { visSamtykkeBanner, BANNER_ID } from '@modulis/samtykke';
import type { ForsideEpiContent } from '../epitekster/types';
import { useForsideteksterContext } from '../context/useForsideteksterContext';

// Ok, jeg vet at dette ser veldig rart og sketchy ut, men det er en grunn til det
// I dag alle non-react applikasjoner setter samtykke skjema lenken i footer gjennom `href=javascript:`
// Og dette er den enkleste måte å gjøre det på i react og ved å beholde et slags sikkerhet fasade
const gyldigVisSamtykke = [
  'javascript:window.visSamtykkeBanner()',

  'javascript:globalThis.visSamtykkeBanner()',

  'javascript:visSamtykkeBanner()',
];

const ListLink = styled(List.Link)(({ theme }) => ({
  ':any-link': {
    color: theme.palette.link['link-default'],
  },
}));

function FooterLenke({ lenke }: { lenke: ForsideEpiContent['footerSoyle1'][number] }) {
  if (gyldigVisSamtykke.includes(lenke.href) || lenke.href?.endsWith(`#${BANNER_ID}`)) {
    return (
      <ListLink
        role="button"
        href={`#${BANNER_ID}`}
        onClick={() => visSamtykkeBanner()}
        title={lenke.title}
        target={lenke.target}
      >
        {lenke.text}
      </ListLink>
    );
  }

  return (
    <ListLink href={lenke.href} title={lenke.title} target={lenke.target}>
      {lenke.text}
    </ListLink>
  );
}

function ForeldresigneringFooter() {
  const forsideTekster = useForsideteksterContext();
  let numberOfColumns = 0;
  if (forsideTekster.footerSoyle1?.length) numberOfColumns++;
  if (forsideTekster.footerSoyle2?.length) numberOfColumns++;
  if (forsideTekster.footerSoyle3?.length) numberOfColumns++;

  return (
    <Box sx={{ textAlign: 'center', mt: '160px' }}>
      <Footer numberOfColumns={numberOfColumns}>
        {!!forsideTekster.footerSoyle1?.length && (
          <List>
            {forsideTekster.footerSoyle1.map((lenke) => (
              <FooterLenke key={`${lenke.href}${lenke.text}`} lenke={lenke} />
            ))}
          </List>
        )}
        {!!forsideTekster.footerSoyle2?.length && (
          <List>
            {forsideTekster.footerSoyle2.map((lenke) => (
              <FooterLenke key={`${lenke.href}${lenke.text}`} lenke={lenke} />
            ))}
          </List>
        )}
        {!!forsideTekster.footerSoyle3?.length && (
          <List>
            {forsideTekster.footerSoyle3.map((lenke) => (
              <FooterLenke key={`${lenke.href}${lenke.text}`} lenke={lenke} />
            ))}
          </List>
        )}
      </Footer>
    </Box>
  );
}

export default ForeldresigneringFooter;
